import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import {
    ActionPreviewEdits,
    ActionPreviewStatusPickerSection,
    ActionPreviewStatusOption,
} from '../../../../../services/gable/gable.service';

/**
 * `status_picker` section of an action-preview card. Renders an
 * always-editable V2 `<mat-select>` showing the action's current status
 * (e.g. "Courtesy Warning" for violation actions). Lives at the card
 * level so non-violation actions (charges, requests, etc.) can opt in
 * without burying the status inside their email-edit modal.
 *
 * Emits `(edit)` with `{ value }` on selection change; the host card
 * merges into `pendingEdits.status_picker`.
 */
@Component({
    selector: 'app-ap-status-picker-section',
    templateUrl: './status-picker-section.component.html',
    styleUrls: ['./status-picker-section.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormsModule, MatFormFieldModule, MatSelectModule],
})
export class ActionPreviewStatusPickerSectionComponent {
    @Input({ required: true }) section!: ActionPreviewStatusPickerSection;
    @Input() pendingEdit: ActionPreviewEdits['status_picker'] | null = null;

    @Output() readonly edit = new EventEmitter<NonNullable<ActionPreviewEdits['status_picker']>>();

    get value(): string {
        return this.pendingEdit?.value ?? this.section.value;
    }

    onSelectionChange(value: string): void {
        this.edit.emit({ value });
    }

    trackByOptionValue(_: number, option: ActionPreviewStatusOption): string {
        return option.value;
    }
}
